/* eslint-disable react/jsx-props-no-spreading */

"use client";

import { useRouter } from "next/navigation";

import BackToRenewal from "@/app/shared-components/back-to-renewal/back-to-renewal";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import CurrentPolicyCoverCard from "@/components/molecules/renewals/current-policy-section/current-policy-cover-section/current-policy-cover-card";
import { CurrentPolicyPoliciesAreaSchema } from "@/schema/renewal-page/current-policy-page.schema";

type CurrentPolicyCoverProps = {
  content: CurrentPolicyPoliciesAreaSchema;
};

function CurrentPolicyCover({ content }: Readonly<CurrentPolicyCoverProps>) {
  const { current } = useWizard();
  const router = useRouter();
  return (
    <div className="flex flex-col lg:items-center md:px-spacing-xxl md:pt-spacing-xxl md:pb-spacing-xl gap-spacing-l md:gap-spacing-xl lg:mb-spacing-m">
      {content?.isBackToDashboardCtaVisible && (
        <div
          className="flex items-center self-start h-[24px]"
          id="back-to-dashboard-area"
        >
          <BackToRenewal
            label={content?.backToDashboardCta ?? "back to renewals"}
            className="font-body-font leading-[18px] font-[600] text-xs py-spacing-xxs top-[-2px] !px-spacing-xxs"
          />
        </div>
      )}
      <div>
        <div className="lg:min-w-[720px] rounded-[16px] bg-transparent !shadow-[0px_4px_8px_0px_rgba(0,0,0,0.15),_0px_1px_3px_0px_rgba(0,0,0,0.20)]">
          <CurrentPolicyCoverCard {...content} />
        </div>
        <div className="pt-spacing-l md:pt-spacing-xl">
          <div className="px-spacing-l md:px-0">
            <h1 className="text-text-title font-header-font text-xl leading-[115.385%] text-center md:text-l md:leading-[112%]">
              {content?.bottomHeader}
            </h1>
          </div>
          <div className="w-[280px] md:w-[241px] lg:w-[226px] mx-auto mt-spacing-l">
            <LabelButtonWrapper
              id="show-cover-levels-button"
              hierarchy="secondary"
              label={content?.seeMoreCoverLevelCta}
              className="!border-[1.5px] text-[18px] leading-[18px] font-[600] bg-surface-neutral-option-1"
              onClick={() =>
                router.push(current.edges?.seeOtherCoverLevels ?? "")
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CurrentPolicyCover;
